import {IMeasureWithCenter, IModel} from "makerjs";
import {makerjs} from "../../../source/js/shared/rendering/makerjs";
import Length from "../../../source/js/shared/models/Geometry/Length";
import Area from "../../../source/js/shared/models/Geometry/Area";

export enum Units {
	MM = 'mm',
	CM = 'cm',
	M = 'm',
}

export default class EnclosedShape {
	private enclosedShape: IMeasureWithCenter;

	constructor( shapeModel: IModel ) {

		// Add fallback model if no valid model is provided.
		if ( ! shapeModel ) {
			shapeModel = new makerjs.models.Rectangle( 0, 0 );
		}
		this.enclosedShape = makerjs.measure.modelExtents( shapeModel );
	}

	center(): Length[] {
		return [
			Length.from_cm( this.enclosedShape.center[ 0 ] ),
			Length.from_cm( this.enclosedShape.center[ 1 ] ),
		];
	}

	high(): Length[] {
		return [
			Length.from_cm( this.enclosedShape.high[ 0 ] ),
			Length.from_cm( this.enclosedShape.high[ 1 ] ),
		];
	}

	low(): Length[] {
		return [
			Length.from_cm( this.enclosedShape.low[ 0 ] ),
			Length.from_cm( this.enclosedShape.low[ 1 ] ),
		];
	}

	height(): Length {
		return Length.from_cm( this.enclosedShape.height );
	}

	width(): Length {
		return Length.from_cm( this.enclosedShape.width );
	}

	mapToUnits( items: Length[], unit: Units ): number[] {
		return items.map( item => item[ `in_${unit}` ]() );
	}

	area(): Area {
		return Area.fromDimensions( this.height(), this.width() );
	}
}
